export enum AlertAttributeKeyTypes {
  FUEL_LEVEL_BEFORE = "fuelLevelBefore",
  FUEL_LEVEL_AFTER = "fuelLevelAfter",
  ESTIMATED_LITERS = "estimatedLiters",
  // Liters the flagged percentage points are worth, by the tank capacity in force (user-provided
  // capacity when set, learned estimate otherwise). Deliberately SEPARATE from ESTIMATED_LITERS,
  // which means different things per event type: on a REFUEL it is the volume that entered the tank
  // (rise + burn during the fill), and on a DROP it is only the part consumption cannot explain.
  EQUIVALENT_LITERS = "equivalentLiters",
  CONSUMED_LITERS = "consumedLiters",
  HIGHEST_TEMPERATURE = "highestTemperature",
  TEMPERATURE_THRESHOLD = "temperatureThreshold"
}
